namespace GeniuzPOS.Inventory {
    export interface IcStockSoldDtForm {
        Id: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        SkuCode: Serenity.LookupEditor;
        ItemRemark: Serenity.StringEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        CostValue: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
    }

    export class IcStockSoldDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockSoldDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockSoldDtForm.init)  {
                IcStockSoldDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(IcStockSoldDtForm, [
                    'Id', w0,
                    'LineItemNo', w0,
                    'SkuCode', w1,
                    'ItemRemark', w2,
                    'UnitChange', w3,
                    'PurUnit', w2,
                    'PurUnitRatio', w4,
                    'PurUnitPrice', w4,
                    'Qty', w4,
                    'CostValue', w4,
                    'UnitCost', w4,
                    'Remark', w2
                ]);
            }
        }
    }
}
